const NotFound = () => {
  return (
    <div className="flex items-center justify-center w-full h-screen max-h-full bg-black">
      <span className="text-white text-3xl font-bold">404: Page not found</span>
    </div>
  );
};

export default NotFound;
